export default __webpack_public_path__ + "static/media/ag-grey.f7b59144.svg";